import {BiobookPage} from '../types';

export const getOrderedBiobookPageFileNames = (biobookPage: BiobookPage) => {
  if (!biobookPage.fileNames) {
    return [];
  }

  return biobookPage.fileNames.slice().sort((a, b) => {
    const aBaseName = a.split('.')[0];
    const bBaseName = b.split('.')[0];
    const aNumber = parseInt(aBaseName.split('-')[1]);
    const bNumber = parseInt(bBaseName.split('-')[1]);
    return aNumber - bNumber;
  });
};
